import { isAndroid, isIOS } from "react-device-detect";

/** 보안키패드 입력요청 (clickSecurityKeypadEvent_Web (WEB > APP)) */
export const clickSecurityKeypadEventWeb = (screenId: string, screenName: string, keypadCode: string, length: string, keypadTitle: string) => {
  if (isIOS && window.webkit) {
    window.webkit.messageHandlers.clickSecurityKeypadEvent_Web.postMessage({ screenId: screenId, screenName: screenName, keypadCode: keypadCode, length: length, keypadTitle: keypadTitle });
  }
  else if (isAndroid && window.appInterface) {
    window.appInterface.clickSecurityKeypadEvent_Web(screenId, screenName, keypadCode, length, keypadTitle);
  }
  else {
    alert("This device is not support clickSecurityKeypadEvent_Web()...");
  }
}

/** 오류메시지 전달 (핀코드 검증오류시) (failEvent_Web (WEB > APP)) */
export const failEventWeb = (code: string, message: string) => {
  if (isIOS && window.webkit) {
    window.webkit.messageHandlers.failEvent_Web.postMessage({ code: code, message: message });
  }
  else if (isAndroid && window.appInterface) {
    window.appInterface.failEvent_Web(code, message);
  }
  else {
    alert("[" + code + "] " + message);
  }
}

/** 거래비밀번호 재설정 화면호출 (findPincode_Web (WEB > APP)) */
export const findPincodeWeb = () => {
  if (isIOS && window.webkit) {
    window.webkit.messageHandlers.findPincode_Web.postMessage({});
  }
  else if (isAndroid && window.appInterface) {
    window.appInterface.findPincode_Web();
  }
  else {
    alert("This device is not support findPincode_Web()...");
  }
}

/** 신분증촬영 요청 (uploadPhotoID_Web (WEB > APP)) */
export const uploadPhotoIdWeb = (idType: string, photoType: string) => {
  if (isIOS && window.webkit) {
    window.webkit.messageHandlers.uploadPhotoID_Web.postMessage({ idType: idType, photoType: photoType });
  }
  else if (isAndroid && window.appInterface) {
    window.appInterface.uploadPhotoID_Web(idType, photoType);
  }
  else {
    alert("This device is not support uploadPhotoID_Web()...");
  }
}

/** 주소촬영 요청 (uploadPhotoAddress_Web (WEB > APP)) */
export const uploadPhotoAddressWeb = () => {
  if (isIOS && window.webkit) {
    window.webkit.messageHandlers.uploadPhotoAddress_Web.postMessage({});
  }
  else if (isAndroid && window.appInterface) {
    window.appInterface.uploadPhotoAddress_Web();
  }
  else {
    alert("This device is not support uploadPhotoAddress_Web()...");
  }
}

/** React 화면 열기 (openReact_Web (WEB > APP)) - 신규 네이티브가 지정 url의 React 화면을 오픈 (url 예: "card/address") ※ 함수명 앱팀 확정 후 교체 */
export const openReactWeb = (url: string) => {
  if (isIOS && window.webkit) {
    window.webkit.messageHandlers.openReact_Web.postMessage(url);
  }
  else if (isAndroid && window.appInterface) {
    window.appInterface.openReact_Web(url);
  }
  else {
    alert("This device is not support openReact_Web()...");
  }
}

/** 이용내역 SNS공유 호출 (clickShare_Web (WEB > APP)) */
export const clickShareWeb = (screenId: string, screenName: string, jsonBody: string) => {
  if (isIOS && window.webkit) {
    window.webkit.messageHandlers.clickShare_Web.postMessage({ screenId: screenId, screenName: screenName, jsonBody: jsonBody });
  }
  else if (isAndroid && window.appInterface) {
    window.appInterface.clickShare_Web(screenId, screenName, jsonBody);
  }
  else {
    alert("This device is not support clickShare_Web()...");
  }
}

/** (2024.02.01) 이용내역 Download 호출 (clickDownload_Web (WEB -> APP)) */
export const clickDownloadWeb = (screenId : string, screenName : string, jsonBody : string) => {
  if (isIOS && window.webkit) {
    window.webkit.messageHandlers.clickDownload_Web.postMessage({ screenId: screenId, screenName: screenName, jsonBody: jsonBody });
  } else if (isAndroid && window.appInterface) {
    window.appInterface.clickDownload_Web(screenId, screenName, jsonBody);
  } else {
    alert("This device is not support clickDownload_Web()...");
  }
}

/** Gmoneypay Detail 화면 이동 (clickGmoneypayDetail_Web (WEB > APP)) */
export const clickGmoneypayDetailWeb = () => {
  if (isIOS && window.webkit) {
    window.webkit.messageHandlers.clickGmoneypayDetail_Web.postMessage({});
  }
  else if (isAndroid && window.appInterface) {
    window.appInterface.clickGmoneypayDetail_Web();
  }
  else {
    alert("This device is not support clickGmoneypayDetail_Web()...");
  }
}

/** 교통카드 이용내역 조회요청 (clickRailplusEvent_Web (WEB > APP)) */
export const clickRailplusEventWeb = (trafficCardNo: string) => {
  if (isIOS && window.webkit) {
    window.webkit.messageHandlers.clickRailplusEvent_Web.postMessage(trafficCardNo);
  }
  else if (isAndroid && window.appInterface) {
    window.appInterface.clickRailplusEvent_Web(trafficCardNo);
  }
  else {
    // alert("This device is not support clickRailplusEvent_Web()...");
  }
}

/** 교통카드 충전이동 (clickRailplusCharge_Web (WEB > APP)) */
export const clickRailplusChargeWeb = () => {
  if (isIOS && window.webkit) {
    window.webkit.messageHandlers.clickRailplusCharge_Web.postMessage({});
  }
  else if (isAndroid && window.appInterface) {
    window.appInterface.clickRailplusCharge_Web();
  }
  else {
    alert("This device is not support clickRailplusCharge_Web()...");
  }
}

/** 레일플러스 바로가기 (clickRailplusHomepage_Web (WEB > APP)) */
export const clickRailplusHomepageWeb = () => {
  if (isIOS && window.webkit) {
    window.webkit.messageHandlers.clickRailplusHomepage_Web.postMessage({});
  }
  else if (isAndroid && window.appInterface) {
    window.appInterface.clickRailplusHomepage_Web();
  }
  else {
    alert("This device is not support clickRailplusHomepage_Web()...");
  }
}

/** 교통카드 메뉴클릭 (clickRailplusMenu_Web (WEB > APP)) */
export const clickRailplusMenuWeb = () => {
  if (isIOS && window.webkit) {
    window.webkit.messageHandlers.clickRailplusMenu_Web.postMessage({});
  }
  else if (isAndroid && window.appInterface) {
    window.appInterface.clickRailplusMenu_Web();
  }
}

/** 교통카드 잔액 조회요청 (iOS) (clickRailplusBalance_Web (WEB > APP)) */
export const clickRailplusBalanceWeb = (trafficCardNo: string) => {
  if (isIOS && window.webkit) {
    window.webkit.messageHandlers.clickRailplusBalance_Web.postMessage(trafficCardNo);
  }
  else if (isAndroid && window.appInterface) {
    window.appInterface.clickRailplusBalance_Web(trafficCardNo);
  }
  else {
    // alert("This device is not support clickRailplusEvent_Web()...");
  }
}

/** 교통카드 이용내역 조회요청 (iOS) (clickRailplusHistory_Web (WEB > APP)) */
export const clickRailplusHistoryWeb = (trafficCardNo: string) => {
  if (isIOS && window.webkit) {
    window.webkit.messageHandlers.clickRailplusHistory_Web.postMessage(trafficCardNo);
  }
  else if (isAndroid && window.appInterface) {
    window.appInterface.clickRailplusHistory_Web(trafficCardNo);
  }
  else {
    alert("This device is not support clickRailplusHistory_Web()...");
  }
}

/** APP 세션갱신 및 타이틀명 전달 (callNative_Web (WEB > APP)) */
export const callNativeWeb = (screenId: string, screenName: string, mainYn: string = "N") => {
  if (isIOS && window.webkit) {
    window.webkit.messageHandlers.callNative_Web.postMessage({ screenId: screenId, screenName: screenName, mainYn: mainYn! });
  }
  else if (isAndroid && window.appInterface) {
    window.appInterface.callNative_Web(screenId, screenName, mainYn!);
  }
}

/** 앱 얼랏 호출 (callAlert_Web (WEB > APP)) */
export const callAlertWeb = (title: string, code: string, message: string) => {
  if (isIOS && window.webkit) {
    window.webkit.messageHandlers.callAlert_Web.postMessage({ title: title, code: code, message: message });
  }
  else if (isAndroid && window.appInterface) {
    window.appInterface.callAlert_Web(title, code, message);
  }
  else {
    alert("[" + code + "] " + message);
  }
}

/** 앱 오류처리 (exceptionEvent_Web (WEB > APP)) */
export const exceptionEventWeb = (code: string, message: string, processPolicy: string) => {
  if (isIOS && window.webkit) {
    window.webkit.messageHandlers.exceptionEvent_Web.postMessage({ code: code, message: message, processPolicy: processPolicy });
  }
  else if (isAndroid && window.appInterface) {
    window.appInterface.exceptionEvent_Web(code, message, processPolicy);
  }
  else {
    alert("[" + code + "] " + message);
  }
}

/** 앱 로그인 요청 (callAppLogin_Web (WEB > APP)) */
export const callAppLoginWeb = () => {
  if (isIOS && window.webkit) {
    window.webkit.messageHandlers.callAppLogin_Web.postMessage({});
  }
  else if (isAndroid && window.appInterface) {
    window.appInterface.callAppLogin_Web();
  }
  else {
    alert("This device is not support callAppLogin_Web()...");
  }
}

/** 하단 메뉴바 처리 (footerShowEvent_Web (WEB > APP)) */
export const footerShowEventWeb = (showYn: string) => {
  if (isIOS && window.webkit) {
    window.webkit.messageHandlers.footerShowEvent_Web.postMessage(showYn);
  }
  else if (isAndroid && window.appInterface) {
    window.appInterface.footerShowEvent_Web(showYn);
  }
}

/** 전화걸기 호출 (phoneCall_Web (WEB > APP)) */
export const phoneCallWeb = (telNo: string) => {
  if (isIOS && window.webkit) {
    window.webkit.messageHandlers.phoneCall_Web.postMessage(telNo);
  }
  else if (isAndroid && window.appInterface) {
    window.appInterface.phoneCall_Web(telNo);
  }
  else {
    alert("This device is not support phoneCall_Web()...");
  }
}

/** 구글지도 호출 (openMap_Web (WEB > APP)) */
export const openMapWeb = (address: string) => {
  if (isIOS && window.webkit) {
    window.webkit.messageHandlers.openMap_Web.postMessage(address);
  }
  else if (isAndroid && window.appInterface) {
    window.appInterface.openMap_Web(address);
  }
  else {
    alert("This device is not support openMap_Web()...");
  }
}

/** 프로그래스 활성화 (showProgress_Web (WEB > APP)) */
export const showProgressWeb = () => {
  if (isIOS && window.webkit) {
    window.webkit.messageHandlers.showProgress_Web.postMessage({});
  }
  else if (isAndroid && window.appInterface) {
    window.appInterface.showProgress_Web();
  }
}

/** 프로그래스 비활성화 (hideProgress_Web (WEB > APP)) */
export const hideProgressWeb = () => {
  if (isIOS && window.webkit) {
    window.webkit.messageHandlers.hideProgress_Web.postMessage({});
  }
  else if (isAndroid && window.appInterface) {
    window.appInterface.hideProgress_Web();
  }
}

/** 연말정산 소득공제 화면 이동 (clickIncomeDeduction_Web (WEB > APP)) */
export const clickIncomeDeductionWeb = () => {
    try {
        if (isIOS && window.webkit) {
            window.webkit.messageHandlers.clickIncomeDeduction_Web.postMessage({});
        }
        else if (isAndroid && window.appInterface) {
            window.appInterface.clickIncomeDeduction_Web();
        }
        else {
            alert("This device is not support clickIncomeDeduction_Web()...");
        }
    } catch (e) {
        try {
            callAlertWeb("", "", "Exception clickIncomeDeduction_Web()");
        } catch (error) {
            console.log(error);
        }
    }
}

/** App 화면 이동 (clickMoveToApp_Web (WEB > APP)) */
export const clickMoveToAppWeb = (appScreenId: string) => {
  try {
    if (isIOS && window.webkit) {
      window.webkit.messageHandlers.clickMoveToApp_Web.postMessage({appScreenId: appScreenId});
    }
    else if (isAndroid && window.appInterface) {
      window.appInterface.clickMoveToApp_Web(appScreenId);
    }
    else {
      alert("This device is not support clickMoveToApp_Web()...");
    }
  } catch (e) {
    try {
      callAlertWeb("", "", "Exception clickMoveToApp_Web()");
    } catch (error) {
      console.log(error);
    }
  }
}

/** 신분증 업로드 호출 (uploadIDCard_Web (WEB > APP)) */
export const uploadIDCardWeb = () => {
  if (isIOS && window.webkit) {
    window.webkit.messageHandlers.uploadIDCard_Web.postMessage({});
  }
  else if (isAndroid && window.appInterface) {
    window.appInterface.uploadIDCard_Web();
  }
  else {
    alert("This device is not support uploadIDCard_Web()...");
  }
}

/** 신분증 재업로드 호출 (reUploadIDCard_Web (WEB > APP)) */
export const reUploadIDCardWeb = () => {
  if (isIOS && window.webkit) {
    window.webkit.messageHandlers.reUploadIDCard_Web.postMessage({});
  }
  else if (isAndroid && window.appInterface) {
    window.appInterface.reUploadIDCard_Web();
  }
  else {
    alert("This device is not support reUploadIDCard_Web()...");
  }
}

/** KYC 인증요청 팝업 호출 (showKycRequiredPopup_Web (WEB > APP)) */
export const showKycRequiredPopupWeb = () => {
  if (isIOS && window.webkit) {
    window.webkit.messageHandlers.showKycRequiredPopup_Web.postMessage({});
  }
  else if (isAndroid && window.appInterface) {
    window.appInterface.showKycRequiredPopup_Web();
  }
  else {
    alert("This device is not support showKycRequiredPopup_Web()...");
  }
}